import { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { Deudor } from "../models/deudor";
import { ParticipanteRequest } from "../models/participantes";
import { DeudorJuridico } from "../models/deudorJuridico";
import { SeguroDeudorEdit } from "../models/seguroDeudorEdit";
import { EliminarSeguroDeudor } from "../models/seguroDeudor";

type MontoAseguradoResponse = {
  MontoAsegurado?: number;
  montoAsegurado?: number;
};

const getDeudor = async (data: ParticipanteRequest) => {

  const axiosResponse: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-participantes/v1/participante-deudor/obtener-deudor`, {
    params: {
      rut: data.rut,
      mutuoId: data.mutuoId
    }
  });

  return axiosResponse;
}

const getDeudorJuridico = async (data: ParticipanteRequest) => {

  const axiosResponse: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-participantes/v1/participante-deudor/obtener-deudor-juridico`, {
    params: {
      rut: data.rut,
      mutuoId: data.mutuoId
    }
  });

  return axiosResponse;
}


const updateDeudor = async (data: Deudor) => {
  const response: AxiosResponse = await axiosInstance.put(`siscred-api-participantes/v1/participante-deudor/actualizar/deudor/${data.rut}`, data);  

  return response;
}

const updateDeudorJuridico = async (data: DeudorJuridico) => {

  const axiosResponse: Promise<AxiosResponse> = axiosInstance.put(`siscred-api-participantes/v1/participante-deudor/actualizar-deudor-juridico/${data.rut}`, data);

  return axiosResponse;
}

const updateSeguroDeudor = async (data: SeguroDeudorEdit) => {
  const axiosResponse: AxiosResponse = await axiosInstance.put(`siscred-api-participantes/v1/participante-deudor/actualizar-seguro/deudor/${data.mutuoId}`, data);

  return axiosResponse;
}
const insertSeguroDeudor = async (data: SeguroDeudorEdit) => {

  const axiosResponse: AxiosResponse = await axiosInstance.post(`siscred-api-participantes/v1/participante-deudor/guardar-seguro-deudor`, data);

  return axiosResponse;
}

const getMontoAsegurado = async (mutuoId: number, tipoSeguro: string) => {

  const axiosResponse = await axiosInstance.get<MontoAseguradoResponse>(`siscred-api-participantes/v1/participante-deudor/obtener-monto-asegurado`, {
    params: {
      mutuoId: mutuoId,
      tipoSeguro: tipoSeguro
    }
  });

  return axiosResponse.data?.MontoAsegurado ?? axiosResponse.data?.montoAsegurado ?? 0;
}

const deleteSeguroDeudor = async (data: EliminarSeguroDeudor) => {

  const axiosResponse: Promise<AxiosResponse> = axiosInstance.delete(`siscred-api-participantes/v1/participante-deudor/eliminar-seguro/deudor/${data.mutuoId}`, {
    params: {
      mutuoId: data.mutuoId,
      seguroId: data.seguroId,
      tipoSeguro: data.tipoSeguro
    }
  });

  return axiosResponse;
}


export {
  getDeudor,
  getDeudorJuridico,
  updateDeudor,
  updateDeudorJuridico,
  updateSeguroDeudor,
  insertSeguroDeudor,
  getMontoAsegurado,
  deleteSeguroDeudor
}